import { default as BrandDefenseFilledSmall } from '../assets/brand-defense-filled-small.svg?react';
import { default as CategoryReviewFilledSmall } from '../assets/category-review-filled-small.svg?react';
import { default as WhosMyShopperFilledSmall } from '../assets/whos-my-shopper-filled-small.svg?react';
import { default as BrandSellInFilledSmall } from '../assets/brand-sell-in-filled-small.svg?react';
import { default as DiagnosingGrowthFilledSmall } from '../assets/diagnosing-growth-filled-small.svg?react';
import { default as IncrementalityFilledSmall } from '../assets/incrementality-filled-small.svg?react';

/**
 * gets survey icon based on route
 * @param  {String} narrativeRoute
 * @return {Node}   react component
 */
export const getNarrativeIcon = (narrativeRoute) => {
  const baseRoutePath = '/dashboard/narrative';

  switch (narrativeRoute) {
    case `${baseRoutePath}/brand-defense`:
      return <BrandDefenseFilledSmall />;
    case `${baseRoutePath}/brand-sell-in`:
      return <BrandSellInFilledSmall />;
    case `${baseRoutePath}/category-review`:
      return <CategoryReviewFilledSmall />;
    case `${baseRoutePath}/diagnosing-growth`:
      return <DiagnosingGrowthFilledSmall />;
    case `${baseRoutePath}/incrementality`:
      return <IncrementalityFilledSmall />;
    case `${baseRoutePath}/who-is-my-shopper`:
      return <WhosMyShopperFilledSmall />;
    default:
      return '';
  }
};
